import {
  Avatar,
  Badge,
  Button,
  ButtonProps,
  Card,
  Flex,
  Group,
  MantineProvider,
  SimpleGrid,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import {
  IconCircleCheckFilled,
  IconMail,
  IconPhone,
} from "@tabler/icons-react";
import { Case, Switch } from "react-if";
import { useParams } from "react-router";
import { isJSON } from "../../../../helpers/helpers";
import { useEffect, useState } from "react";

function SuccessComponent({
  title,
  assignUsers,
  actions,
}: {
  title: string;
  assignUsers: any;
  actions?: {
    label: string;
    url: string;
    style?: ButtonProps;
  }[];
}) {
  return (
    <MantineProvider>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          maxWidth: 600,
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          padding: 40,
          borderRadius: 10,
        }}
      >
        <IconCircleCheckFilled
          size={70}
          style={{
            color: "green",
          }}
        />

        <Stack align="center" justify="center" mt={18}>
          <Title order={1} fz={24}>
            {title}
          </Title>

          <Flex justify="flex-start">
            <Title ta="start" order={2} fz={16}>
              Assigned Staff
            </Title>
          </Flex>
          <SimpleGrid mb={28} c="dimmed">
            {assignUsers?.map((users: any) => {
              return (
                <Card withBorder>
                  <Group>
                    <Avatar
                      w={50}
                      h={50}
                      src={
                        users?.assignedUserInfo?.profile_picture_url ??
                        "/assets/empty-states/dummy-profile-pic.jpg"
                      }
                    />
                    <Stack align="flex-start" justify="start" gap={2}>
                      <Group>
                        <Text fw={600}>
                          {users?.assignedUserInfo?.full_name}
                        </Text>
                        <Badge>{users?.assignedUserIdentityInfo?.alias}</Badge>
                      </Group>

                      <Flex gap={18}>
                        <Group gap={6} align="center">
                          <IconMail size={16} />
                          <Text>{users?.assignedUserInfo?.email}</Text>
                        </Group>

                        <Group gap={6} align="center">
                          <IconPhone size={16} />
                          <Text>{users?.assignedUserInfo?.phone_number}</Text>
                        </Group>
                      </Flex>
                    </Stack>
                  </Group>
                </Card>
              );
            })}
          </SimpleGrid>

          <Group>
            {actions?.map((action, index) => (
              <Button
                w="max-content"
                size="md"
                component="a"
                key={index}
                href={action.url}
                style={{
                  marginTop: 10,
                  marginBottom: 10,
                  backgroundColor: "",
                }}
                {...action.style}
              >
                {action.label}
              </Button>
            ))}
          </Group>
        </Stack>
      </div>
    </MantineProvider>
  );
}

export default function SuccessPage() {
  const params = useParams();
  const [assignUsers, setAssignUsers] = useState<any>(null);

  useEffect(() => {
    setAssignUsers(
      isJSON(localStorage.getItem("lead_assigned_staff"))
        ? JSON.parse(localStorage.getItem("lead_assigned_staff") as any)
        : []
    );
  }, []);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <Switch>
        <Case condition={params?.["moduleType-signup"]?.includes("agent")}>
          <SuccessComponent
            title="Request submitted successfully!"
            assignUsers={
              // isJSON(localStorage.getItem("agent_assigned_staff"))
              //   ? JSON.parse(
              //       localStorage.getItem("agent_assigned_staff") as any
              //     )
              //   : []
              assignUsers ?? []
            }
          />
        </Case>
        <Case condition={params?.["moduleType-signup"]?.includes("lead")}>
          <SuccessComponent
            title="Request submitted successfully!"
            assignUsers={
              isJSON(localStorage.getItem("lead_assigned_staff"))
                ? JSON.parse(localStorage.getItem("lead_assigned_staff") as any)
                : []
            }
            // paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
          />
        </Case>
        <Case
          condition={params?.["moduleType-signup"]?.includes("application")}
        >
          <SuccessComponent
            title="Request submitted successfully!"
            assignUsers={
              isJSON(localStorage.getItem("application_assigned_staff"))
                ? JSON.parse(
                    localStorage.getItem("application_assigned_staff") as any
                  )
                : []
            }
            // paragraph="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor."
          />
        </Case>
      </Switch>
    </div>
  );
}
